module.exports = __webpack_public_path__ + "static/media/new_jardin_noble_17082023.4fdbca3c.png";